
    <div class="page-wrapper">
    <app-bees-header></app-bees-header>

        <div class="stricky-header stricked-menu main-menu">
            <div class="sticky-header__content"></div><!-- /.sticky-header__content -->
        </div><!-- /.stricky-header -->



        <!--Page Header Start-->
        <section class="page-header">
            <div class="page-header__bg" style="background-image: url(assets/images/backgrounds/page-header-bg.jpg);">
            </div>
            <div class="container">
                <div class="page-header__inner">
                    <div class="page-header__img-1">
                        <img src="assets/images/resources/page-header-img-1.png" alt="">
                    </div>
                    <div class="page-header__shape-1 float-bob-y">
                        <img src="assets/images/shapes/page-header-shape-1.png" alt="">
                    </div>
                    <h3>Gallery</h3>
                    <div class="thm-breadcrumb__inner">
                        <ul class="thm-breadcrumb list-unstyled">
                            <li><a href="index.html">Home</a></li>
                            <li><span class="fas fa-angle-right"></span></li>
                            <li>Gallery</li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
        <!--Page Header End-->

        <!-- Team Page Start -->
        <section class="team-page">
            <div class="container">
                <div class="row">
                    <!-- Team Two Single Start -->
                    <div class="col-xl-3 col-lg-6 col-md-6">
                        <div class="team-two__single">
                            <div class="team-two__img-box">
                                <div class="team-two__img">
                                    <img src="assets/images/team/team-2-1.jpg" alt="">
                                  
                                </div>
                            </div>
                            
                        </div>
                    </div>
                    <!-- Team Two Single End -->
                    <!-- Team Two Single Start -->
                    <div class="col-xl-3 col-lg-6 col-md-6">
                        <div class="team-two__single">
                            <div class="team-two__img-box">
                                <div class="team-two__img">
                                    <img src="assets/images/team/team-2-2.jpg" alt="">
                                   
                                </div>
                            </div>
                         
                        </div>
                    </div>
                    <!-- Team Two Single End -->
                    <!-- Team Two Single Start -->
                    <div class="col-xl-3 col-lg-6 col-md-6">
                        <div class="team-two__single">
                            <div class="team-two__img-box">
                                <div class="team-two__img">
                                    <img src="assets/images/team/team-2-3.jpg" alt="">
                                   
                                </div>
                            </div>
                          
                        </div>
                    </div>
                    <!-- Team Two Single End -->
                    <!-- Team Two Single Start -->
                    <div class="col-xl-3 col-lg-6 col-md-6">
                        <div class="team-two__single">
                            <div class="team-two__img-box">
                                <div class="team-two__img">
                                    <img src="assets/images/team/team-2-4.jpg" alt="">
                                    
                                </div>
                            </div>
                           
                        </div>
                    </div>
                    <!-- Team Two Single End -->
                    <!-- Team Two Single Start -->
                    <div class="col-xl-3 col-lg-6 col-md-6">
                        <div class="team-two__single">
                            <div class="team-two__img-box">
                                <div class="team-two__img">
                                    <img src="assets/images/team/team-2-5.jpg" alt="">
                                    
                                </div>
                            </div>
                          
                        </div>
                    </div>
                    <!-- Team Two Single End -->
                    <!-- Team Two Single Start -->
                    <div class="col-xl-3 col-lg-6 col-md-6">
                        <div class="team-two__single">
                            <div class="team-two__img-box">
                                <div class="team-two__img">
                                    <img src="assets/images/team/team-2-6.jpg" alt="">
                                   
                                </div>
                            </div>
                         
                        </div>
                    </div>
                    <!-- Team Two Single End -->
                    <!-- Team Two Single Start -->
                    <div class="col-xl-3 col-lg-6 col-md-6">
                        <div class="team-two__single">
                            <div class="team-two__img-box">
                                <div class="team-two__img">
                                    <img src="assets/images/team/team-2-7.jpg" alt="">
                                  
                                </div>
                            </div>
                          
                        </div>
                    </div> <!-- Team Two Single Start -->
                    <div class="col-xl-3 col-lg-6 col-md-6">
                        <div class="team-two__single">
                            <div class="team-two__img-box">
                                <div class="team-two__img">
                                    <img src="assets/images/team/team-2-8.jpg" alt="">
                                  
                                </div>
                            </div>
                            
                        </div>
                    </div>
                   
                  
                </div>
            </div>
        </section>
        <!-- Team Page End -->

    <app-bees-footer></app-bees-footer>





    </div><!-- /.page-wrapper -->
